import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ButtonGerar, Campo, Panel, IdentificacaoSection } from './styles';
import ButtonsCrud from '../ButtonsCrud';
import axios from '../../../services/withAxios';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import brLocale from 'date-fns/locale/pt-BR'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import MaskCpf from '../../../utils/MaskCpf/index'
import ConfiguracaoFiscalTab from './ConfiguracaoFiscalTab'

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    gerar: (_: any) => void;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, gerar, ...other } = props;

    return (
        <Panel
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1, display: 'flex', flexDirection: 'column' }} component="form" {...other} onSubmit={gerar}>
                    {children}
                </Box>
            )}
        </Panel>
    );
}

function a11yProps(index: number) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

export default function MenuFiscalTabs({ onTabChange }: { onTabChange?: (index: number) => void }) {
    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);
    const [mesAno, setMesAno] = React.useState<Date | null>(null);
    const [cpfCnpj, setCpfCnpj] = React.useState('');

    const [de, setDe] = React.useState<Date | null>(null);
    const [ate, setAte] = React.useState<Date | null>(null);

    const handleTabSwitch = (event: React.SyntheticEvent, newValue: number) => {
        setCurrentTabIndex(newValue);
        onTabChange?.(newValue);
    };

    const handleGerarArquivo = (e: any, type: string) => {
        e.preventDefault();

        var endpoint = "";
        var nomeArquivo = "";
        var parametros = {};

        switch (type) {
            case "registros":
                if (!mesAno)
                    return;

                endpoint = "menufiscal/arquivoI"
                nomeArquivo = "registros.txt"
                parametros = {
                    ano: mesAno.getFullYear(),
                    mes: mesAno.getMonth()
                }
                break;
            case "vendas":
                if (!de || !ate)
                    return;

                endpoint = "menufiscal/arquivoII"
                nomeArquivo = "vendasPorCPNJ.txt"
                parametros = {
                    de,
                    ate,
                    cpfCnpj
                }
                break;
            case "requisitoXI":
                endpoint = "menufiscal/requisitoXI"
                nomeArquivo = "requisitoXI.xml"
                break;
            default:
                break;
        }

        axios.post(endpoint, parametros, {
            responseType: 'blob',
        }).then(response => {
            try {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;

                link.download = nomeArquivo;
                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);
            } catch (error) {
                console.error('Erro ao baixar o arquivo:', error);
            }
        });
    }

    return (
        <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex' }}
        >
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={currentTabIndex}
                onChange={handleTabSwitch}
                aria-label="Menu Fiscal Tabs"
                sx={{ borderRight: 1, borderColor: 'divider' }}
            >
                <Tab label="Identificação do PAF-NFCe" {...a11yProps(0)} />
                <Tab label="Registros do PAF-NFCe" {...a11yProps(1)} />
                <Tab label="Vendas Identificadas pelo CPF/CNPJ" {...a11yProps(2)} />
                <Tab label="XML Requisito XI" {...a11yProps(3)} />
                <Tab label="Configuração Fiscal" {...a11yProps(4)} />
            </Tabs>
            <TabPanel value={currentTabIndex} index={0} gerar={e => handleGerarArquivo(e, "identificacao")}>
                <IdentificacaoSection>
                    <Typography variant="h6" component="h1">Empresa Desenvolvedora</Typography>
                    <p><b>CNPJ:</b> 49.315.270/0001-80</p>
                    <p><b>Razão Social:</b> JLSCHERER TECH LTDA</p>
                    <p><b>Endereço:</b> DOLORES DURAN, 205, BLUMENAU - SC</p>
                    <p><b>Telefone:</b> (47) 99213-0536</p>
                    <p><b>Contato:</b> JOHANN LUCAS SCHERER</p>
                </IdentificacaoSection>
                <hr />
                <IdentificacaoSection>
                    <Typography variant="h6" component="h1">PAF-NFCe</Typography>
                    <p><b>Nome Comercial:</b> GFL - Gestao de Fluxo de Loja</p>
                    <p><b>Versão:</b> 1.0.0</p>
                    <p><b>Arquitetura Sistema de Gestão:</b> Banco de dados na nuvem - Microsoft do Brasil Ltda</p>
                    <p><b>Arquitetura PAF-NFCe:</b> PAF-NFC-e Nuvem - Microsoft do Brasil Ltda</p>
                </IdentificacaoSection>
            </TabPanel>
            <TabPanel value={currentTabIndex} index={1} gerar={e => handleGerarArquivo(e, "registros")}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={brLocale}>
                    <DatePicker
                        label="Ano e Mes"
                        value={mesAno}
                        autoFocus
                        //inputFormat="MM"
                        views={['year', 'month']}
                        onChange={(novaData) => {
                            setMesAno(novaData);
                        }}
                        renderInput={(params) => <TextField required style={{ margin: "1vh 0 1vh 0" }} size='small' {...params} />}
                    />
                </LocalizationProvider>
                <ButtonGerar type="submit">
                    Gerar
                </ButtonGerar>
            </TabPanel>
            <TabPanel value={currentTabIndex} index={2} gerar={e => handleGerarArquivo(e, "vendas")}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={brLocale}>
                    <DatePicker
                        label="De"
                        value={de}
                        autoFocus
                        inputFormat="dd/MM/yyyy"
                        onChange={(novaData) => {
                            setDe(novaData);
                        }}
                        renderInput={(params) => <TextField required style={{ margin: "1vh 0 1vh 0" }} size='small' {...params} />}
                    />
                    <DatePicker
                        label="Até"
                        value={ate}
                        inputFormat="dd/MM/yyyy"
                        onChange={(novaData) => {
                            setAte(novaData);
                        }}
                        renderInput={(params) => <TextField required style={{ margin: "1vh 0 1vh 0" }} size='small' {...params} />}
                    />
                </LocalizationProvider>
                <Campo
                    id="cpfCnpj"
                    label="CPF"
                    placeholder="000.000.000-00"
                    InputProps={{
                        inputComponent: MaskCpf as any
                    }}
                    value={cpfCnpj}
                    onChange={(e) => setCpfCnpj(e.target.value)}
                    fullWidth
                    autoComplete='off'
                    inputProps={{ style: { textTransform: "uppercase" } }}
                />
                <ButtonGerar type="submit">
                    Gerar
                </ButtonGerar>
            </TabPanel>
            <TabPanel value={currentTabIndex} index={3} gerar={e => handleGerarArquivo(e, "requisitoXI")}>
                <ButtonGerar type="submit">
                    Gerar
                </ButtonGerar>
            </TabPanel>
            <TabPanel value={currentTabIndex} index={4} gerar={e => e.preventDefault()}>
                <ConfiguracaoFiscalTab />
            </TabPanel>
        </Box>
    );
}